class p {
  _size;
  _map;
  constructor() {
    Object.defineProperty(this, "_map", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "_size", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this._size = 0, this._map = /* @__PURE__ */ new Map();
  }
  get size() {
    return this._size;
  }
  get(e) {
    const t = this._map.get(e);
    return t ? new Set(t) : /* @__PURE__ */ new Set();
  }
  put(e, t) {
    let r = this._map.get(e);
    r || (r = /* @__PURE__ */ new Set());
    const s = r.size;
    return r.add(t), r.size === s ? !1 : (this._map.set(e, r), this._size++, !0);
  }
  has(e) {
    return this._map.has(e);
  }
  hasEntry(e, t) {
    const r = this._map.get(e);
    return r ? r.has(t) : !1;
  }
  delete(e) {
    const t = this._map.get(e);
    return t && this._map.delete(e) ? (this._size -= t.size, !0) : !1;
  }
  deleteEntry(e, t) {
    const r = this._map.get(e);
    return r && r.delete(t) ? (this._size--, !0) : !1;
  }
  clear() {
    this._map.clear(), this._size = 0;
  }
  entries() {
    const e = this;
    function* t() {
      for (const [r, s] of e._map.entries())
        for (const i of s)
          yield [r, i];
    }
    return t();
  }
  values() {
    const e = this;
    function* t() {
      for (const [, r] of e.entries())
        yield r;
    }
    return t();
  }
  keys() {
    return this._map.keys();
  }
  forEach(e, t) {
    for (const [r, s] of this.entries())
      e.call(t === void 0 ? this : t, r, s, this);
  }
  [Symbol.iterator] = () => this.entries();
}
class g {
  _params;
  constructor(e) {
    Object.defineProperty(this, "_params", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this._params = new p();
    const r = e.hash.slice(1).split("&");
    for (const s of r) {
      const i = s.split("=");
      if (!i[0]) continue;
      const l = i[0];
      let o = null;
      i.length === 2 && i[1] && (o = i[1]), this._params.put(l, o);
    }
  }
  append(e, t = null) {
    this._params.put(e, t);
  }
  delete(e) {
    this._params.delete(e);
  }
  get(e) {
    const [t] = this._params.get(e);
    return t || null;
  }
  getAll(e) {
    return this._params.get(e);
  }
  keys() {
    return this._params.keys();
  }
  toString() {
    const e = [];
    return this._params.forEach((t, r) => {
      r ? e.push(`${t}=${r}`) : e.push(t);
    }), e.join("&");
  }
}
const R = new TextEncoder(), m = (n) => new g(n), _ = (n) => {
  let e = n.toString();
  return n.search && (e = e.replace(n.search, "")), n.hash && (e = e.replace(n.hash, "")), new URL(e);
}, b = (n) => {
  let e = decodeURIComponent(n);
  for (; w(e); )
    e = decodeURIComponent(e);
  return e.startsWith("http") || (e = `http://${e}`), e;
}, w = (n) => n !== decodeURIComponent(n || ""), v = async (n) => {
  const e = R.encode(n), t = await crypto.subtle.digest("SHA-256", e);
  return Array.from(new Uint8Array(t)).map((s) => s.toString(16).padStart(2, "0")).join("");
}, x = (n) => {
  const e = [];
  return n.forEach((t, r) => {
    t ? e.push(`${r}=${encodeURIComponent(t)}`) : e.push(r);
  }), e.join("&");
};
class y {
  // @ts-ignore
  name;
  // @ts-ignore
  urlPattern;
  enabled_rules = {};
  enabled_exceptions = {};
  enabled_redirections = {};
  enabled_rawRules = {};
  enabled_referralMarketing = {};
  referralMarketing;
  /**
   * Declare constructor
   */
  constructor(e, {
    completeProvider: t = !1,
    urlPattern: r,
    rules: s = [],
    rawRules: i = [],
    referralMarketing: l = [],
    exceptions: o = [],
    redirections: d = []
  }, c = !0) {
    this.name = e, t && (this.enabled_rules[".*"] = !0), this.setURLPattern(r);
    for (const a of s)
      this.addRule(a);
    for (const a of i)
      this.addRawRule(a);
    for (const a of l)
      this.addReferralMarketing(a);
    for (const a of o)
      this.addException(a);
    for (const a of d)
      this.addRedirection(a);
    this.referralMarketing = c;
  }
  /**
   * Add URL pattern.
   */
  setURLPattern = (e) => {
    this.urlPattern = new RegExp(e, "i");
  };
  /**
   * Apply a rule to a given tuple of rule array.
   * @param enabledRuleArray - for enabled rules
   * @param rule - RegExp as string
   */
  applyRule = (e, t) => {
    e[t] = !0;
  };
  /**
   * Add a rule to the rule array
   * and replace old rule with new rule.
   *
   * @param rule - rule as string
   */
  addRule = (e) => {
    this.applyRule(this.enabled_rules, e);
  };
  /**
   * Return all active rules as an array.
   *
   * @return Array RegExp strings
   */
  getRules = () => this.referralMarketing ? Object.keys(this.enabled_rules) : Object.keys(
    Object.assign(this.enabled_rules, this.enabled_referralMarketing)
  );
  /**
   * Add a raw rule to the raw rule array
   * and replace old raw rule with new raw rule.
   *
   * @param rule - rule as string
   */
  addRawRule = (e) => {
    this.applyRule(this.enabled_rawRules, e);
  };
  /**
   * Return all active raw rules as an array.
   *
   * @return Array RegExp strings
   */
  getRawRules = () => Object.keys(this.enabled_rawRules);
  /**
   * Add a referral marketing rule to the referral marketing array
   * and replace old referral marketing rule with new referral marketing rule.
   *
   * @param rule - rule as string
   */
  addReferralMarketing = (e) => {
    this.applyRule(this.enabled_referralMarketing, e);
  };
  /**
   * Add a exception to the exceptions array
   * and replace old with new exception.
   *
   * @param exception - exception as string
   */
  addException = (e) => {
    this.enabled_exceptions[e] = !0;
  };
  /**
   * Private helper method to check if the url
   * an exception.
   *
   * @param url - url as string
   * @return matching?
   */
  matchException = (e) => {
    let t = !1;
    for (const r in this.enabled_exceptions) {
      if (t) break;
      t = new RegExp(r, "i").test(e);
    }
    return t;
  };
  /**
   * Add a redirection to the redirections array
   * and replace old with new redirection.
   *
   * @param redirection - RegExp as string
   */
  addRedirection = (e) => {
    this.enabled_redirections[e] = !0;
  };
  /**
   * Return all redirection.
   *
   * @return url
   */
  getRedirection = (e) => {
    let t = null;
    for (const r in this.enabled_redirections) {
      const s = e.match(new RegExp(r, "i"));
      if (s && s.length > 0 && r) {
        t = new RegExp(r, "i").exec(e)?.[1] || null;
        break;
      }
    }
    return t;
  };
  getName = () => this.name;
  /**
   * Check the url is matching the ProviderURL.
   */
  matchURL = (e) => this.urlPattern.test(e) && !this.matchException(e);
  /**
   * Helper function whichs remove the tracking fields
   * for each provider given as parameter.
   *
   * @param pureUrl - URL as String
   * @return Array with changes and url fields
   */
  removeFieldsFormURL = (e) => {
    let t = e, r = "", s, i;
    const l = this.getRules();
    let o = !1;
    const d = this.getRawRules();
    let c = new URL(t);
    const a = this.getRedirection(t);
    if (a !== null)
      return t = b(a), {
        redirect: !0,
        url: t
      };
    for (const h of d) {
      const f = t;
      t = t.replace(new RegExp(h, "gi"), ""), f !== t && (o = !0);
    }
    if (c = new URL(t), i = c.searchParams, s = m(c), r = _(c).toString(), i.toString() !== "" || s.toString() !== "") {
      for (const f of l) {
        for (const u of i.keys())
          new RegExp(`^${f}$`, "gi").test(u) && (i.delete(u), o = !0);
        for (const u of s.keys())
          new RegExp(`^${f}$`, "gi").test(u) && (s.delete(u), o = !0);
      }
      let h = r;
      i.toString() !== "" && (h += `?${x(i)}`), s.toString() !== "" && (h += `#${s.toString()}`), t = h.replace(/\?&/, "?").replace(/#&/, "#");
    }
    return {
      changes: o,
      url: t
    };
  };
}
class k {
  referralMarketing;
  onFetchedRules;
  providers = {};
  constructor({
    hashUrl: e,
    ruleUrl: t,
    hashFromMemory: r,
    rulesFromMemory: s,
    onFetchedRules: i,
    referralMarketing: l = !0
  }) {
    if (!t && !s)
      throw new Error(
        "Either rule URL or a prefetched ruleset must be provided"
      );
    this.referralMarketing = l, this.onFetchedRules = i, s && this.createProviders(s), t && (r && e ? this.fetchHash(e).then((o) => {
      o !== r && this.fetchRules(t).then(this.createProviders);
    }) : this.fetchRules(t).then(this.createProviders));
  }
  createProviders = (e) => {
    this.providers = {};
    for (const [t, r] of Object.entries(e.providers))
      this.providers[t] = new y(
        t,
        r,
        this.referralMarketing
      );
  };
  /**
   * Clears tracking elements from a URL.
   * @param url - The URL to clear tracking elements from.
   * @returns URL without tracking elements.
   */
  clearUrl = (e) => {
    let t = {
      url: e,
      redirect: !1
    };
    for (const r of Object.values(this.providers))
      if (r.matchURL(t.url) && (t = r.removeFieldsFormURL(t.url)), t.redirect)
        return t.url;
    return t.url;
  };
  /**
   * Sets rules provided by the user.
   * @param rules - The rules object.
   * @param _hash - The sha256 hash of the rules object (currently unused).
   */
  setRules = (e, t) => {
    this.createProviders(e);
  };
  /**
   * Sets the URLs for rules database and hash source.
   * @param ruleUrl - The URL for the rules database.
   * @param _hashUrl - The URL for the hash source (currently unused).
   */
  setUrls = (e, t) => {
    this.fetchRules(e).then(this.createProviders);
  };
  fetchHash = async (e) => await (await fetch(e)).text();
  fetchRules = async (e) => {
    const r = await (await fetch(e)).text(), s = JSON.parse(r);
    return v(r).then((i) => {
      this.onFetchedRules && this.onFetchedRules(i, s);
    }), s;
  };
}
export {
  k as URLPurify
};
//# sourceMappingURL=main.es.js.map
